import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  selector: 'vi-icon',
  standalone: true,
  imports: [CommonStandaloneModule],
  templateUrl: 'icon.component.html',
  styleUrls: ['icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViIconComponent {
  @Input() name: string;
  @Input() size = 24;

  getIconUrl(): string {
    return `./assets/icons/${this.name.toLowerCase()}.svg`;
  }

  getSize(): string {
    return `${this.size}px`;
  }
}
